import { render, staticRenderFns } from "./ProcessSensor.vue?vue&type=template&id=4a88b8f2&"
import script from "./ProcessSensor.vue?vue&type=script&lang=js&"
export * from "./ProcessSensor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports